import { queryOptions, useQuery } from '@tanstack/react-query';

import type { DevToolKey } from '@/devTools/config';
import { loadDevTools } from '@/server/devtools/load-dev-tools';

export const DEV_TOOLS_QUERY_KEY = ['dev-tools'] as const;

export type DevToolsMap = Record<DevToolKey, boolean>;

export const devToolsQueryOptions = () =>
  queryOptions({
    queryKey: DEV_TOOLS_QUERY_KEY,
    queryFn: async () => (await loadDevTools()) as DevToolsMap,
    staleTime: 5 * 60 * 1000,
  });

export function useDevTools() {
  return useQuery(devToolsQueryOptions());
}

export function useDevToolToggle(key: DevToolKey) {
  const query = useDevTools();

  return {
    value: !!query.data?.[key],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  } as const;
}
